<div class="image-library-container">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h6 class="mb-0">Global Image Library</h6>
    <small class="text-muted">Upload images here, then reference them by filename in your CSV's "Image URL" column</small>
  </div>

  <!-- Drop zone -->
  <div class="drop-zone mb-4" [class.drag-over]="dragOver"
       (dragover)="$event.preventDefault(); dragOver=true"
       (dragleave)="dragOver=false"
       (drop)="$event.preventDefault(); dragOver=false; onDrop($event)">
    <nb-icon icon="cloud-upload-outline" style="font-size:2rem"></nb-icon>
    <p class="mb-1">Drag &amp; drop images here or <label class="text-link" for="globalImageInput">browse</label></p>
    <small class="text-muted">JPEG, PNG, GIF, WebP — max 5 MB each, up to 50 at once</small>
    <input type="file" id="globalImageInput" accept="image/*" multiple hidden (change)="onFilesSelected($event)">
    <div *ngIf="isUploading" class="mt-2 text-primary">
      <nb-spinner status="primary" size="small"></nb-spinner>
      <span class="ms-2">Uploading…</span>
    </div>
  </div>

  <!-- Image grid -->
  <div *ngIf="isLoading" class="text-center py-3">
    <nb-spinner status="primary"></nb-spinner>
  </div>
  <div *ngIf="!isLoading && images.length === 0" class="text-center text-muted py-4">No images uploaded yet</div>
  <div class="image-grid" *ngIf="!isLoading && images.length > 0">
    <div class="image-card" *ngFor="let img of images">
      <img [src]="img.url" [alt]="img.filename" class="image-thumb">
      <div class="image-info">
        <small class="filename text-truncate d-block" [title]="img.filename">{{ img.filename }}</small>
        <div class="image-actions mt-1">
          <button class="btn btn-xs btn-outline-secondary me-1" (click)="copyFilename(img.filename)" title="Copy filename for CSV">
            <nb-icon icon="copy-outline"></nb-icon> Filename
          </button>
          <button class="btn btn-xs btn-outline-secondary me-1" (click)="copyUrl(img.url)" title="Copy full URL">
            <nb-icon icon="link-2-outline"></nb-icon> URL
          </button>
          <button class="btn btn-xs btn-outline-danger" (click)="deleteImage(img.filename)" title="Delete">
            <nb-icon icon="trash-2-outline"></nb-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
